'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hourglassWidth = exports.hourglassHeight = exports.hourglassDefaultColor = exports.hourglassCapHeight = exports.hourglassAnimationSpeed = exports.hourglassAngle = exports.hourglassActiveColor = undefined;

var _arenaConfig = require('arena-config');

var c = _interopRequireWildcard(_arenaConfig);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var hourglassActiveColor = exports.hourglassActiveColor = c.ORANGE;
var hourglassAngle = exports.hourglassAngle = '9px';
var hourglassAnimationSpeed = exports.hourglassAnimationSpeed = '2s';
var hourglassCapHeight = exports.hourglassCapHeight = 4;
var hourglassDefaultColor = exports.hourglassDefaultColor = 'rgba(0, 0, 0, .125)';
var hourglassHeight = exports.hourglassHeight = '20px';
var hourglassWidth = exports.hourglassWidth = '24px';